import React from 'react';
import { Spin, Row, Col, message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
const antIcon = <LoadingOutlined style={{ fontSize: 24, alignSelf:'center', color:'#888' }} spin />;
 
const LoadingIndicator = ({ menssagem }) => (
    <Row style={{marginTop:'5%'}}>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
        
        </Col>
        
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
        <Row >
            <Col span={6}>
                <Spin style={{alignSelf:'center'}} indicator={antIcon} />
            </Col>
            <Col span={18}>
            {menssagem}
            </Col>
        </Row>
        </Col>
        <Col xs={24} sm={24} md={8} lg={8} xl={8}>
        
        </Col>
    </Row>
);

export default LoadingIndicator;